import { NavigateFunction, useNavigate } from 'react-router-dom';

import { slugify } from '@/utils/misc';
import { ADMIN_ROUTE_PATH } from '@/administration/constants/adminRoutePaths';
import { ROUTE_PATH } from '@/constants/routePaths';

export const useLearnerCourseHref = (): {
  courseStartPage: (ops: { id: number; title: string }) => string;
  courseViewPage: (ops: { id: number; title: string }) => string;
  courseLearningJourneyPage: (ops: { id: number; title: string }) => string;
  courseLearningJourneySectionPage: (ops: { journeyId: number; sectionId: number; journeyTitle: string }) => string;
  adminEditorHref: (ops: { id: number; title: string }) => string;
  adminInsightsHref: (id: number) => string;
} => {
  return {
    courseStartPage: (ops: { id: number; title: string }) => `${ROUTE_PATH.LEARNING_BASE}/${ops.id}/${slugify(ops.title)}`,
    courseViewPage: (ops: { id: number; title: string }) => `${ROUTE_PATH.LEARNING_BASE}/${ops.id}/${slugify(ops.title)}/view`,
    courseLearningJourneyPage: (ops: { id: number; title: string }) =>
      `${ROUTE_PATH.JOURNEY_BASE}/${ops.id}/${slugify(ops.title)}`,
    courseLearningJourneySectionPage: (ops: { journeyId: number; sectionId: number; journeyTitle: string }) =>
      `${ROUTE_PATH.JOURNEY_BASE}/${ops.journeyId}/${slugify(ops.journeyTitle)}/section/${ops.sectionId}`,
    adminEditorHref: (ops: { id: number; title: string }) => `${ADMIN_ROUTE_PATH.COURSES_V2}/${ops.id}/${slugify(ops.title)}`,
    adminInsightsHref: (id: number) => `/administration/catalog/learning/urn:collegial:${id}/insights`,
  };
};

export const useLearnerCourseNavigate = (): {
  navigate: NavigateFunction;
  navigate404: () => void;
  navigateToCourseStart: (ops: { id: number; title: string }) => void;
  navigateToCourseView: (ops: { id: number; title: string }) => void;
  navigateToCourseLearningJourney: (ops: { id: number; title: string }) => void;
  navigateToAdminEditor: (ops: { id: number; title: string }) => void;
  navigateToAdminInsights: (id: number) => void;
} => {
  const navigate = useNavigate();
  const href = useLearnerCourseHref();
  return {
    navigate,
    navigate404: () => navigate(ROUTE_PATH.NOT_FOUND),
    navigateToCourseStart: (ops: { id: number; title: string }) => navigate(href.courseStartPage(ops)),
    navigateToCourseView: (ops: { id: number; title: string }) => navigate(href.courseViewPage(ops)),
    navigateToCourseLearningJourney: (ops: { id: number; title: string }) => navigate(href.courseLearningJourneyPage(ops)),
    navigateToAdminEditor: (ops: { id: number; title: string }) => navigate(href.adminEditorHref(ops)),
    navigateToAdminInsights: (id: number) => navigate(href.adminInsightsHref(id)),
  };
};
